import { omniAtom } from "src/utils/atoms";
import { OpenBasePlanogramReviewModal } from "./hooks";

export const basePlanogramReviewAtom = omniAtom({
  key: "modals/basePlanogramReview",
  value: null as null | OpenBasePlanogramReviewModal,
});
